import { useEffect } from 'react';

const GlobalSchema = () => {
  useEffect(() => {
    const globalSchemaData = {
      "@context": "https://schema.org",
      "@type": "Course",
      "name": "ScholarsToday",
      "url": "https://scholarstoday.id/",
      "description": "ScholarsToday adalah platform belajar IELTS online di Indonesia yang membantu pelajar mencapai target skor IELTS dengan cara belajar yang lebih terarah, terjangkau, dan didampingi mentor berpengalaman. Didirikan pada tahun 2025 di Kampung Inggris, Pare.",
      "sameAs": [
        "https://instagram.com/scholarstoday.id"
      ]
    };

    const script = document.createElement('script');
    script.type = 'application/ld+json';
    script.innerHTML = JSON.stringify(globalSchemaData);
    script.id = 'global-schema'; // Beri ID agar mudah dikenali di Inspect Element

    document.head.appendChild(script);

    return () => {
      // Cleanup jika komponen dibongkar (meskipun untuk App.jsx ini jarang terjadi)
      const existingScript = document.getElementById('global-schema');
      if (existingScript) {
        document.head.removeChild(existingScript);
      }
    };
  }, []);

  return null; 
};

export default GlobalSchema;